module.exports = __webpack_public_path__ + "img/Rectangle75.3077e447.png";